import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Authcontext } from "./Authcontext";
import { apiUrl } from "../ApiUrl/ApiUrl";

export const CartContext = createContext();

const CartContextProvider = ({ children }) => {
  const { correct } = useContext(Authcontext);
  const [cartData, SetCartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderpageData, setOrderpageData] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("orderpageData")) || [];
    } catch {
      return [];
    }
  });
  const [globalAddress, setGlobalAddress] = useState({});

  const clearCart = useCallback(() => {
    SetCartData([]);
    setOrderpageData([]);
    setGlobalAddress({});
    localStorage.removeItem("orderpageData");
    localStorage.removeItem("order_id");
  }, []);

  const getData = useCallback((overrideUid) => {
    const rawUid = overrideUid !== undefined ? overrideUid : localStorage.getItem("uid");
    const activeUid = rawUid !== null && rawUid !== undefined ? String(rawUid).trim() : "";
    const isAuth = localStorage.getItem("loginCheck") === "true";

    // If user is logged out or uid is missing, ensure cart is completely empty
    if (!isAuth || !activeUid || activeUid === "null" || activeUid === "undefined" || activeUid === "") {
      SetCartData([]);
      setLoading(false);
      return Promise.resolve([]);
    }

    setLoading(true);
    return fetch(`${apiUrl}/public/getAllCartById?uid=${encodeURIComponent(activeUid)}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch cart");
        return res.json();
      })
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        SetCartData(data);
        return data;
      })
      .catch((err) => {
        console.error("Error fetching cart data:", err);
        SetCartData([]);
        return [];
      })
      .finally(() => setLoading(false));
  }, []);

  // Sync cart when authentication status changes
  useEffect(() => {
    const isAuth = localStorage.getItem("loginCheck") === "true";
    const currentUid = localStorage.getItem("uid");
    const cleanUid = currentUid !== null && currentUid !== undefined ? String(currentUid).trim() : "";

    if (isAuth && cleanUid !== "" && cleanUid !== "null" && cleanUid !== "undefined") {
      getData(cleanUid);
    } else {
      clearCart();
    }
  }, [correct, getData, clearCart]);

  const carturl = `${apiUrl}/public/getAllCartById?uid=${localStorage.getItem("uid") || ""}`;

  return (
    <CartContext.Provider
      value={{
        cartData,
        SetCartData,
        loading,
        setOrderpageData,
        orderpageData,
        setLoading,
        getData,
        clearCart,
        globalAddress,
        setGlobalAddress,
        carturl,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;